import { motion } from "framer-motion";

const RobotLogo = ({ size = 40 }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="flex items-center gap-2 cursor-pointer select-none"
      title="Akash's Portfolio"
    >
      {/* SVG Robot */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ filter: "drop-shadow(0 0 6px rgba(6,182,212,0.5))" }}
      >
        {/* Antenna base */}
        <motion.rect
          x="30"
          y="2"
          width="4"
          height="8"
          rx="2"
          fill="currentColor"
          className="text-primary"
          animate={{ scaleY: [1, 1.2, 1] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Antenna ball */}
        <motion.circle
          cx="32"
          cy="2"
          r="3"
          fill="currentColor"
          className="text-primary"
          animate={{ opacity: [1, 0.4, 1], scale: [1, 1.3, 1] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Head */}
        <rect x="14" y="10" width="36" height="26" rx="6" fill="#1e293b" />
        <rect
          x="14"
          y="10"
          width="36"
          height="26"
          rx="6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="text-primary"
          strokeOpacity="0.6"
        />

        {/* Left Eye */}
        <motion.rect
          x="19"
          y="18"
          width="10"
          height="8"
          rx="3"
          fill="currentColor"
          className="text-primary"
          animate={{ opacity: [1, 0.5, 1] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.rect
          x="22"
          y="20"
          width="4"
          height="4"
          rx="2"
          fill="white"
          animate={{ opacity: [1, 0.7, 1] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Right Eye */}
        <motion.rect
          x="35"
          y="18"
          width="10"
          height="8"
          rx="3"
          fill="currentColor"
          className="text-primary"
          animate={{ opacity: [1, 0.5, 1] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
        />
        <motion.rect
          x="38"
          y="20"
          width="4"
          height="4"
          rx="2"
          fill="white"
          animate={{ opacity: [1, 0.7, 1] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
        />

        {/* Mouth */}
        <rect x="22" y="31" width="20" height="3" rx="1.5" fill="#334155" />
        <motion.rect
          x="22"
          y="31"
          width="7"
          height="3"
          rx="1.5"
          fill="currentColor"
          className="text-primary"
          animate={{ x: [0, 13, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Neck */}
        <rect x="28" y="36" width="8" height="4" rx="1" fill="#334155" />

        {/* Body */}
        <rect x="10" y="40" width="44" height="20" rx="6" fill="#1e293b" />
        <rect
          x="10"
          y="40"
          width="44"
          height="20"
          rx="6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="text-primary"
          strokeOpacity="0.4"
        />

        {/* Body center orb */}
        <motion.circle
          cx="32"
          cy="50"
          r="5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="text-primary"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.circle
          cx="32"
          cy="50"
          r="2.5"
          fill="currentColor"
          className="text-primary"
          animate={{ opacity: [0.6, 1, 0.6], scale: [0.8, 1.1, 0.8] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Left body dot */}
        <motion.circle
          cx="20"
          cy="50"
          r="2"
          fill="currentColor"
          className="text-primary"
          animate={{ opacity: [0.3, 0.8, 0.3] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
        />

        {/* Right body dot */}
        <motion.circle
          cx="44"
          cy="50"
          r="2"
          fill="currentColor"
          className="text-primary"
          animate={{ opacity: [0.3, 0.8, 0.3] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        />
      </svg>

      {/* Name text */}
      <span
        className="font-heading font-bold text-xl text-primary tracking-wide hidden sm:inline"
        style={{ letterSpacing: "0.04em" }}
      >
        Akash<span className="text-foreground opacity-60">.dev</span>
      </span>
    </motion.div>
  );
};

export default RobotLogo;
